import React, {useState, useEffect} from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
// import { FiSave } from "react-icons/fi"; 

const Reward = ()=>{
    const [msisdn, setMsisdn ] = useState('');
    const [amount, setAmount ] = useState('');
    const [redirect, setRedirect] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const[loading, setLoading] = useState(false);
    const [hasError,setHasError] = useState(false);
    const[walletStatus, setWalletStatus] = useState(0);

    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`rewardWalletStatus`);
            setWalletStatus(data.wallet_amount);

            console.log(data);

        }
        )();
    }, []);
    
    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`rewardnomination/${id}`);
                 setMsisdn(data.msisdn); 
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            setLoading(true);
            setErrorMessage("");
            setHasError(false);

            try {
                const {data} = await axios.post(`reward/${id}`, {
                    msisdn,
                    amount, 
                });

                const responseCode = data.response_code
                if(responseCode === "1"){
                    setErrorMessage(data.message);
                    setHasError(true);
                }
                if(responseCode === "0"){
                    setRedirect(true);
                }
                
            } catch (error) {
                if (error.message === "Network Error") {
                    setErrorMessage("Failed to connect to the server. Please try again later.");
                } else if(error.code==="ERR_BAD_REQUEST"){
                    setErrorMessage("Bad Request Try again");
                } else {
                    setErrorMessage("An error occurred. Please try again later.");
                } 
                setHasError(true);
            }finally{
                setLoading(false);
            }

          
        
    };
   
    if(redirect){
         return <Navigate to={'/rewardnomination'} />
    }
    return (
        <Wrapper pageTitle={'Reward, Bal: ' + walletStatus}>
        
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Msisdn </span>
                        <input 
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Msisdn" value={msisdn}
                        onChange = {e => setMsisdn(e.target.value)}  readOnly/>
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Amount</span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Amount" value={amount}
                        onChange = {e => setAmount(e.target.value)} />
                    </label>
 
 
                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         disabled={loading}
                         > 
                         {loading ? 'Posting...' : 'Reward'}
                         </button>
                         {hasError&&
                (
                <div className="bg-red-500 text-white leading-5 text-center mt-4 text-sm  px-4 py-2">
                    {errorMessage}
                </div>
                )
                }
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default Reward;